module.exports = __webpack_public_path__ + "img/leadership-1980-meeting.cc81831a.jpg";